import React, { useState } from "react";
import {
  Card,
  CardBody,
  Label,
  FormGroup,
  Row,
  Input,
  Container,
  CardHeader,
  CardFooter,
  Button,
  Form, FormFeedback
} from "reactstrap";
import { Link, useHistory } from "react-router-dom";
import axios from 'axios';
import SimpleHeader from "components/Headers/SimpleHeader.js";

export default function CreateCategory() {
  const token = localStorage.token;
  const [categoryName, setCategoryName] = useState("");
  const [categoryNameError, setCategoryNameError] = useState(null);
  let history = useHistory();
  const [isLoading, setLoading] = useState(false);

  const [categoryDuplicate, setCategoryDuplicate] = useState(null);

  const validateForm = () => {
    let error = false;
    if (categoryName === "") {
      setCategoryNameError("invalid");
      error = true;
    }
    return error;
  };

  function CreateData() {
    setLoading(true);
    let data = {
      merchantCategoryName: categoryName
    }
    axios.post(`${process.env.REACT_APP_API_BASE_URL}/merchantCategories/save`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    })
      .then(function (response) {
        if (response.data.error) {
          showErrors(response.data.error);
          return;
        }
        history.push("/admin/category");
      })
      .then(json => {
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error)
      })
  }

  const showErrors = (error) => {
    let errors = false;
    if (error.error_message) {
      setCategoryNameError("invalid");
      setCategoryDuplicate(error.error_message);
      errors = true;
    }
    return errors;
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) {
      CreateData();
    }
  }
  return (
    <>
      <SimpleHeader name="Daftar Kategori" parentName="Admin" />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <Card>
              <CardBody>
                <Form onSubmit={handleSubmit} >
                  <CardHeader>
                    <h3>Daftar Kategori</h3>
                  </CardHeader>
                  <CardBody>
                    <FormGroup>
                      <Label
                        className="form-control-label"
                        htmlFor="serial_number"
                      >
                        Nama Kategori
                                            </Label>
                      <Input
                        type="text"
                        name="kategori_name"
                        placeholder="Masukan Nama Kategori"
                        value={categoryName}
                        invalid={categoryNameError === "invalid"}
                        onChange={(e) => {
                          setCategoryName(e.target.value);
                          if (e.target.value !== "") {
                            setCategoryNameError("");
                          }
                        }}
                      />
                      <FormFeedback>
                        {
                          categoryName === "" ? "Nama Kategori tidak boleh kosong" : categoryDuplicate
                        }
                      </FormFeedback>
                    </FormGroup>
                  </CardBody>
                  <CardFooter>
                    {!isLoading && (<Button color="primary" type="submit">
                      Simpan
                    </Button>)}
                    {isLoading && (<Button color="primary" disabled>
                      <i className="fas fa-spinner fa-spin"></i>{""}
                      loading...
                    </Button>)}
                    <Link class="btn btn-info" to="/admin/category">
                      Cancel
                    </Link>
                  </CardFooter>
                </Form>
              </CardBody>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
}
